import { render, staticRenderFns } from "./character-detail-dialog.vue?vue&type=template&id=2e914cb2&scoped=true&"
import script from "./character-detail-dialog.vue?vue&type=script&lang=ts&"
export * from "./character-detail-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./character-detail-dialog.vue?vue&type=style&index=0&id=2e914cb2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e914cb2",
  null
  
)

export default component.exports